// Check if a value is either a number or a numeric string.
// Should return false:
// - NaN 
// - Infinity and -Infinity
// - null/undefined
// - non-numeric strings
// - empty strings
export function isNumeric(value) {
  if (typeof value === 'number') {
    return isFinite(value);
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const num = Number(value);
    return !isNaN(num) && isFinite(num);
  }

  return false;
}